import getConfig from 'next/config';
import { RoomClass } from '../enums';
var _ref = getConfig() || {},
  _ref$publicRuntimeCon = _ref.publicRuntimeConfig,
  publicRuntimeConfig = _ref$publicRuntimeCon === void 0 ? {} : _ref$publicRuntimeCon;
export var serverSideCookieOptions = {
  httpOnly: false,
  domain: publicRuntimeConfig.NEXT_PUBLIC_COOKIES_DOMAIN,
  maxAge: 30 * 60 * 1000
};
export var BASKET_DETAILS_STORAGE_KEY = 'BasketDetailsState';
export var BASIC_BASKET_DETAILS_INITIAL_VALUE = {
  hotelId: '',
  nightsNumber: 0,
  adultsNumber: 0,
  childrenNumber: 0,
  endDate: '',
  startDate: '',
  rateCode: '',
  reservationId: '',
  bookingFlowId: ''
};
export var BASKET_DETAILS_STATE_INITIAL_VALUE = {
  hotelId: '',
  arrival: '',
  departure: '',
  numberOfUnits: 0,
  numberOfNights: 0,
  selectedRate: {
    ratePlanCode: '',
    roomTypes: [],
    rateCategory: '',
    cellCode: ''
  },
  roomClass: RoomClass.ST,
  rateName: '',
  roomTypeInformationResponse: {
    isLoadingRoomTypeInformation: false,
    dataRoomTypeInformation: {
      roomTypeInformation: {
        roomTypes: []
      }
    },
    isErrorRoomTypeInformation: false,
    errorRoomTypeInformation: null
  },
  bookingFlow: {
    bookingFlowItems: []
  },
  phoneNumber: '',
  brand: 'PI',
  silentSubstitutionLabels: [],
  prevReservationId: ''
};
export var SILENT_SUBSTITUTION_STORAGE_KEY = 'SilentSubstitutionRoomLabels';
export var BASKET_DETAILS_REDIS_TTL = 30 * 60;